import { userActions, alertActions, maintenanceActions } from 'actions';
import { history, getPath, store } from 'helpers';

export function handleResponse(response) {
  return response.text().then((text) => {
    let data = null;
    let parseError = false;
    if (text) {
      try {
        data = JSON.parse(text);
      } catch (e) {
        parseError = true;
      }
    }
    if (parseError && !response.ok) {
      return Promise.reject(
        new Error(
          'Une erreur est survenue. Veuillez réessayer dans quelques instants après avoir actualisé la page.'
        )
      );
    }
    if (!response.ok) {
      if (response.status === 401) {
        let u = null;
        try {
          const userString = localStorage.getItem('user');
          u = userString ? JSON.parse(userString) : null;
        } catch (e) {
          localStorage.removeItem('user');
        }

        if (u && u.refresh_token) {
          store.dispatch(userActions.loginRefresh(u.refresh_token));
        } else {
          // auto logout if 401 response returned from api
          store.dispatch(userActions.logout());
          history.push(getPath('login'));
          store.dispatch(alertActions.error('Votre session a expirée, veuillez vous reconnecter.'));
        }
      }
      if (response.status === 503) {
        store.dispatch(maintenanceActions.success({ ...data, is_alive: false }));
        history.push(getPath('maintenance'));
      }
      if (data && data.error) {
        return Promise.reject(data.error_description);
      }
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }
    return data;
  });
}
